export default __webpack_public_path__ + "fa4f18fd2a22d5529eea83de99e34750.gif";